'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import * as HoverCardPrimitive from '@radix-ui/react-hover-card';
import * as React from 'react';
import { cx } from '../../utils';
const baseClasses = {
    base: 'bg-popover text-popover-foreground z-50 w-64 rounded-md border outline-none',
    fw: 'fw-bg-white fw-border fw-border-shuttle-gray-100 fw-z-10 fw-w-64 fw-rounded-md fw-outline-none'
};
const HoverCardContent = React.forwardRef(({ className, align = 'center', sideOffset = 4, ...props }, ref) => {
    return (_jsx(HoverCardPrimitive.Content, { ref: ref, align: align, sideOffset: sideOffset, className: cx(baseClasses.fw, baseClasses.base, className), ...props }));
});
HoverCardContent.displayName = HoverCardPrimitive.Content.displayName;
const HoverCard = HoverCardPrimitive.Root;
const HoverCardTrigger = HoverCardPrimitive.Trigger;
export { HoverCard, HoverCardTrigger, HoverCardContent };
//# sourceMappingURL=HoverCard.js.map